'use strict';

// Services
import ListModel from 'common/components/list/listModel.service';
import { validAccess } from 'accessControl';

const __endpoints = require('endpoints.service');

export default class ReportingMarketsList extends ListModel {
	constructor(reduxKey) {
		super(reduxKey);
		this.headers = [
			{
				name: 'name',
				type: 'string',
				canAdd: true,
				canEdit: true,
				required: true,
			},
		];
		this.settings = {
			name: 'ReportingMarketsList',
			canAdd: true,
			canEdit: true,
			canDelete: true,
			pageTitle: true,
			searchList: {
				canAdd: true,
				canDelete: true,
			},
			canManipulate: () => validAccess(undefined, ['Global BI Configuration']),

			translationPath: 'REPORTING.REPORTING_MARKETS',
			endpoint: __endpoints.collection.reporting.reporting_markets,
		};
		this.init();
		return this;
	}
}
